import React, { useEffect } from 'react';

const AttributionCapture = ({ storeLocal = false }) => {
  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const clickId = params.get("gclid") || params.get("gbraid") || params.get("wbraid");

    if (clickId) {
      if (storeLocal) {
        localStorage.setItem("clickId", clickId);
      }

      fetch("https://1xvznbv2ue.execute-api.ca-central-1.amazonaws.com/captureAttribution", {
        method: "POST",
        credentials: "include",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ clickId })
      }).catch(err => console.error("Failed to send click ID", err));
    }
  }, [storeLocal]);

  return null; // This component has no UI
};

export default AttributionCapture;
